export const selectStyles = {
  control: (styles, { menuIsOpen, selectProps }) => {
    const startSmall = selectProps.styleStartModeSmall;

    return !menuIsOpen && startSmall
      ? {
          ...styles,
          boxSizing: 'border-box',
          width: '162px',
          height: '40px',
          borderRadius: '4px',
          border: 'solid 1px #3e88ff',
          backgroundColor: '#3e88ff',
          ':hover': {
            boxShadow: '0 4px 8px 0 rgba(59, 116, 168, 0.2)',
            cursor: 'pointer'
          }
        }
      : startSmall
      ? {
          ...styles,
          width: '536px',
          height: '40px',
          borderRadius: '3px',
          boxshadow: '0 4px 8px 0 rgba(59, 116, 168, 0.2)',
          border: 'solid 1px #3e88ff',
          backgroundColor: 'white'
        }
      : {
          ...styles,
          paddingLeft: '8px',
          height: '40px',
          borderRadius: '3px',
          border: !menuIsOpen ? 'solid 1px #dde6f2' : 'solid 1px #3e88ff',
          backgroundColor: 'white',
          boxShadow: menuIsOpen && '0 4px 8px 0 rgba(59, 116, 168, 0.2)',
          ':hover': {
            borderRadius: '3px',
            borderColor: !menuIsOpen ? '#dde6f2' : '#3e88ff',
            cursor: 'pointer'
          },
          ':focus-within': {
            borderColor: '#3e88ff',
            boxShadow: '0 4px 8px 0 rgba(59, 116, 168, 0.2)'
          }
        };
  },
  valueContainer: styles => ({
    ...styles,
    display: 'flex',
    paddingLeft: '16px',
    paddingRight: '0px'
  }),

  menu: (styles, { selectProps }) => {
    const startSmall = selectProps.styleStartModeSmall;
    return {
      ...styles,
      width: startSmall ? '536px' : '100%',
      marginTop: '4px',
      borderRadius: '3px',
      boxShadow: '0 4px 8px 0 rgba(59, 116, 168, 0.2)',
      backgroundColor: 'white',
      zIndex: 2
    };
  },
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      padding: '0',
      margin: '0',
      backgroundColor: isFocused ? '#f6faff' : null,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? '' : '#f6faff')
      }
    };
  },
  menuList: styles => ({ ...styles, padding: '0 16px 0 16px' })
};
